<template>
  <b-alert class="announcement" show :variant="announcement.variant">
    <p class="announcement-text">{{announcement.content}}</p>
    <hr />
    <div class="row announcement-footer">

      <div class="col-9 pr-1">
      <div
          class="text-left"
      >{{ announcement.created_at | date }} {{announcement.fullname}}</div>
    </div>
      <div class="align-self-center col-3 pl-0">
        <b-dropdown text="Edytuj" class="announcement-edit">
          <b-dropdown-item-button @click="$emit('edit', announcement)">Edytuj</b-dropdown-item-button>
          <b-dropdown-item-button class="danger" @click="$emit('remove', announcement)">
          <i class="fas fa-trash-alt"></i> Usuń
        </b-dropdown-item-button>
        </b-dropdown>
      </div>
    </div>
  </b-alert>
</template>

<script>

import {formatDateTime} from "@/services/helpers";
export default {
  name: "AnnouncementItem",
  props: {
    announcement: {
      type: Object,
      default: () => {
        return {};
      }
    },
    editable: { type: Boolean }
  },
  filters: {
    date(value) {
      return formatDateTime(value, "YYYY-MM-DD HH:mm");
    }
  },


};
</script>
